export enum ProjectModeEnum {
  OPEN = 10,
  RESTRICTED = 20,
}

export const PROJECT_TYPES = ['BUILDING', 'INFRASTRUCTURE', 'ENERGY'] as const;
export type ProjectType = (typeof PROJECT_TYPES)[number];

export const PROJECT_TYPE_DESCRIPTIONS_TEXT = {
  BUILDING: {
    en: 'Buildings from housing, offices and industrial buildings to hospitals, data centres, energy centres, treatment plants and land-based aquaculture.',
    nb: 'Bygg fra bolig, kontor og industribygg til sykehus, datasenter, energisentral, renseanlegg og landbasert akvakultur.',
  },
  INFRASTRUCTURE: {
    en: 'Road, rail and metro, stations and transport hubs, airports with terminals, utility networks (water, district heating and gas), and ports, locks and waterways.',
    nb: 'Veg, bane og T-bane, stasjoner og knutepunkt, lufthavner med terminalbygg, ledningsnett (VA, fjernvarme og gass), og havner, sluser og farleder.',
  },
  ENERGY: {
    en: 'Power grid and transformer stations, hydropower and dams, renewable generation (onshore wind, solar and storage), and onshore oil and gas (pipelines and facilities).',
    nb: 'Kraftnett og transformatorstasjoner, vannkraft og dammer, fornybar kraftproduksjon (vind på land, sol og batteri), og olje og gass på land (rørledninger og anlegg).',
  },
};

export enum ProjectUserRoles {
  ADMIN = 'project_admin',
  MEMBER = 'project_member',
}
